// Adónde llevan los botones de los avisos (menú de la campana y página de avisos): al lugar exacto del que hablan

// Avisos de tickets y solicitudes: llevan a «Mis tickets» para dar seguimiento
export const TICKET_LINK_TYPES = ['TICKET_RESPUESTA', 'TICKET_ACTUALIZADO',
  'SOLICITUD_RECIBIDA', 'SOLICITUD_RESUELTA', 'SOLICITUD_NOVEDAD', 'SOLICITUD_NO_PROCEDE'];

// La reserva de la que habla el aviso (Reservas la busca y la muestra primero). Un aviso viejo sin su id lleva a la lista de la vista
// guardada en data.rol
export const rutaReserva = (notif) => (notif.data?.bookingId
  ? `/user/reservas-proveedor?reserva=${notif.data.bookingId}`
  : `/user/reservas-proveedor?vista=${notif.data?.rol === 'cliente' ? 'cliente' : 'proveedor'}`);

// Avisos de la cuenta en la que se cobra. El mismo tipo también avisa que la cuenta ya quedó lista: por eso el botón no dice «Conectar»
const TIPOS_DATOS_PAGOS = ['PAYMENT_ONBOARDING', 'PAYMENT_NO_CLABE'];

// Los que ya traen su propio botón (solicitudes, invitaciones, cotizaciones y tickets)
const TIPOS_CON_BOTON = ['BOOKING_REQUEST', 'BOOKING_MODIFICATION_REQUEST', 'BOOKING_MODIFIED', 'PAGE_INVITATION',
  'INVITATION_REJECTED', 'COTIZACION_SOLICITADA', ...TICKET_LINK_TYPES];

// El botón de un aviso que no trae el suyo: { texto, ruta }, o null si no habla de una reserva ni de la cuenta para cobrar
export const botonAviso = (notif) => {
  if (TIPOS_DATOS_PAGOS.includes(notif.type)) return { texto: 'Ir a Datos para pagos', ruta: '/mi-perfil?seccion=pagos' };
  if (TIPOS_CON_BOTON.includes(notif.type) || !notif.data?.bookingId) return null;
  return { texto: 'Ver reserva', ruta: rutaReserva(notif) };
};
